import { notification } from 'core/services/notification';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { userDomain } from '@user';
import { confirmDialog } from 'primereact/confirmdialog';
import { useCallback } from 'react';

export const useUnblockUserMutation = (
  options?: UseMutationOptions<userDomain.User, unknown, number | string>,
) => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (id: number | string) => {
      return userDomain.userRepository.unblock(id);
    },
    {
      onSuccess: async (...args) => {
        await queryClient.invalidateQueries([userDomain.userResourceUrl]);
        notification({
          header: 'Разблокирован',
          content: 'Пользователь разблокирован',
          type: 'success',
        });
        options?.onSuccess && options.onSuccess(...args);
      },
    },
  );

  const unblockUser = useCallback(
    (id: number | string) => {
      confirmDialog({
        header: 'Разблокировка',
        message: 'Вы действительно хотите разблокировать пользователя?',
        acceptLabel: 'Разблокировать',
        rejectLabel: 'Отмена',
        accept: () => mutation.mutateAsync(id),
      });
    },
    [mutation],
  );

  return {
    unblockUser,
    ...mutation,
  };
};
